import { DefaultActions, Separator, Showing, Total, Search, Wrapper } from '@/components/Grid/components/header/Heading';
import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useDataExtractorStore } from '../../store';
import HeaderButtons from '../HeaderButtons';

import useSearchConfiguration from './hooks/useSearchConfiguration';
import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function DataExtractorGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  useSearchConfiguration()

  return <DefaultGrid
    heading={<Wrapper>
      <Search />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions add={<HeaderButtons />} />
    </Wrapper>}
  />
}

export default function DataExtractorGridLayout() {
  return <GridProvider store={useDataExtractorStore()}>
    <DataExtractorGrid />
  </GridProvider>
}
